import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/fleet',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'fleet',
        },
        children: [
            {
                path: '',
                redirect: { name: 'fleet-dashboard' },
            },
            {
                path: 'dashboard',
                name: 'fleet-dashboard',
                component: () => import('./views/FleetDashboard.vue'),
            },
            {
                path: 'employees/:username',
                name: 'fleet-employee-detail',
                component: () => import('./views/FleetEmployeeDetail.vue'),
                props: true,
            },
            {
                path: 'assets',
                name: 'fleet-assets',
                component: () => import('./views/FleetAssets.vue'),
            },
            {
                path: 'assets/:machineId',
                name: 'fleet-asset-detail',
                component: () => import('./views/FleetAssetDetail.vue'),
                props: true,
            },
            {
                path: 'registrations',
                name: 'fleet-registrations',
                component: () => import('./views/FleetRegistrations.vue'),
            },
            {
                path: 'enrollment-keys',
                name: 'fleet-enrollment-keys',
                component: () => import('./views/FleetEnrollmentKeys.vue'),
            },
            {
                path: 'map',
                name: 'fleet-map',
                component: () => import('./views/FleetMap.vue'),
            },
            {
                path: 'releases',
                name: 'fleet-releases',
                component: () => import('./views/FleetReleases.vue'),
            },
            {
                path: 'releases/:releaseId',
                name: 'fleet-release-detail',
                component: () => import('./views/FleetReleaseDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
